// @flow
import { httpClient } from 'angieslist-app-platform';
import queryString from 'query-string';

export type ContactTypeMetrics = {
  contactType: string,
  contactCount: number,
}

export type ContactGroupMetrics = {
  aggregatedContactCount: number,
  categoryGroup: {},
}

export type GetContactMetricsByServiceProviderRequest = {
  serviceProviderId: number,
  startTime: Date,
  endTime: Date,
};

export type GetCallLogByServiceProviderRequest = {
  serviceProviderId: number,
  offset: number,
  numberOfEntries: number,
};

export type GetCallLogByServiceProviderResponse = {
  callLog: {},
};

export type GetContactMetricsCategoryGroupsByServiceProviderRequest = {
  serviceProviderId: number,
  startTime: Date,
  endTime: Date,
};

export type GetContactMetricsByServiceProviderResponse = {
  aggregatedContactCount: number,
  contactTypeMetrics: ContactTypeMetrics[]
};

export type GetContactMetricsCategoryGroupsByServiceProviderResponse = {
  aggregatedContactCount: number,
  contactTypeMetrics: ContactTypeMetrics[],
  contactGroupMetrics: ContactGroupMetrics[],
};

export type CustomerAttributesRequest = {
  serviceProviderId: number,
  uuid: string,
};

export type CustomerAttributesResponse = {
  activities: {
    proProfileViewsCount?: number,
    proDirectoryViewsCount?: number,
  }
};

const getContactMetricsByServiceProvider = ({
  serviceProviderId,
  startTime,
  endTime,
}: GetContactMetricsByServiceProviderRequest): any =>
  httpClient.get(`/gateway/office-home/v1/contacts/service_provider/${serviceProviderId}/metrics?${queryString.stringify({
    startTime: startTime.toISOString(),
    endTime: endTime.toISOString(),
  })}`, {
    headers: { 'X-ANGI-CallerId': serviceProviderId },
  });

const getContactMetricsCategoryGroupsByServiceProvider = ({
  serviceProviderId,
  startTime,
  endTime,
}: GetContactMetricsCategoryGroupsByServiceProviderRequest): any =>
  httpClient.get(`/gateway/office-home/v1/contacts/service_provider/${serviceProviderId}/metrics/category_groups?${queryString.stringify({
    startTime: startTime.toISOString(),
    endTime: endTime.toISOString(),
  })}`, {
    headers: { 'X-ANGI-CallerId': serviceProviderId },
  });

const getCallLogByServiceProvider = ({
  serviceProviderId,
  offset,
  numberOfEntries,
}: GetCallLogByServiceProviderRequest): any =>
  httpClient.get(`/gateway/notification/v2/callAttribution/getPhoneCallActivity?serviceProviderId=${serviceProviderId}&limit=${numberOfEntries}&offset=${offset}`, {
    headers: {
      'X-ANGI-CallerId': serviceProviderId,
    },
  });

const getCustomerAttributesByUuid = ({ serviceProviderId, uuid }: CustomerAttributesRequest): any =>
  httpClient.get(`/gateway/office-home/v1/customer_attributes/${uuid}`, {
    headers: {
      'X-ANGI-CallerType': 'ServiceProvider',
      'X-ANGI-CallerId': serviceProviderId,
    },
  });

export default {
  getContactMetricsByServiceProvider,
  getContactMetricsCategoryGroupsByServiceProvider,
  getCallLogByServiceProvider,
  getCustomerAttributesByUuid,
};



// WEBPACK FOOTER //
// ./src/modules/home/common/performanceService.js